import { render, staticRenderFns } from "./noneBC.vue?vue&type=template&id=8097a0a4&"
import script from "./noneBC.vue?vue&type=script&lang=js&"
export * from "./noneBC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8097a0a4', component.options)
    } else {
      api.reload('8097a0a4', component.options)
    }
    module.hot.accept("./noneBC.vue?vue&type=template&id=8097a0a4&", function () {
      api.rerender('8097a0a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/request/extend/noneBC.vue"
export default component.exports